import classNames from 'classnames';
import React, { useState, useRef, useEffect } from 'react';
import styles from './style.module.scss';
import Heading from 'shared/components/common/heading/Heading';
import { logoSite, Printer } from 'assets';
import OverlayLoading from 'shared/screen_loader/overlay_loader/OverlayLoading';
import CustomButton from 'shared/components/common/custom_button/CustomButton';
import { useReactToPrint } from 'react-to-print';
import { useLocation } from 'react-router-dom';
import { formatPrice } from 'shared/utils/Helper';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import moment from 'moment';
import ModalImage from 'shared/components/common/custom_image_lightbox/ModalImage';
import ImageViewer from '../manage_task/ImageViewer';

export default function LayoutPo({ poDataProp, hidePrintButton }) {
    const componentRef = useRef(null);
    const location = useLocation();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current
    });
    const sourceData = poDataProp || location?.state?.data || {};
    const [orderPO, setorderPO] = useState(sourceData?.order || []);
    const [dataPO, setdataPO] = useState(sourceData);
    const [address, setAddress] = useState('Shop # 54,Ground Floor,Century Tower,Main Link Road.');
    const [city, setCity] = useState('Lahore, Punjab');
    const [postal, setPostal] = useState('54000');
    const [email, setEmail] = useState('Techbizzksa@gmail.com');

    useEffect(() => {
        if (sourceData) {
            let clone = { ...dataPO };
            let list = sourceData?.order?.map((ii) => {
                return {
                    ...ii,
                    amount: ii?.price * ii?.quantity
                };
            });
            clone.order = list || [];
            setdataPO(clone);
        }
    }, []);
    console.log(dataPO,"dataPOdataPO");
    const formatPrice = (price) => {
        const num = Number(price);
        if (isNaN(num)) return 'Rs 0.00';
        return `Rs ${num.toFixed(2)}`;
    };


    return (
        <div className={classNames(styles.mainpoLyout)}>
            {!hidePrintButton && (
                <div className={classNames(styles.butoonprint)}>
                    <CustomButton Icon={Printer} submitHandle={() => handlePrint()} IconStyle={classNames('me-1', styles.IconStyle)} text={'Print'} containerStyle={classNames(styles.AddProduct)} />
                </div>
            )}
            <div ref={componentRef} className={classNames(styles.UserContainer)}>
                <div className={classNames(styles.ourdress, styles.totalsPo)}>
                    <div className={classNames(styles.cusFlex)} style={{ alignItems: 'flex-start', textAlign: 'left' }}>
                        <h4 style={{ display: 'flex', alignItems: 'center', margin: 0, paddingBottom: '15px' }}>
                            <img src={logoSite} alt="logo" style={{ marginRight: '10px' }} /> Wise Tech
                        </h4>
                        <div className={styles.printLabelGroup}>
                            <label>Address:</label>
                            <input
                                className={styles.printOnlyHide}
                                value={address}
                                onChange={(e) => setAddress(e.target.value)}
                                placeholder="Address"
                            />
                            <span className={styles.printOnlyShow}>{address}</span>
                        </div>

                        <div className={styles.printLabelGroup}>
                            <label>City/State:</label>
                            <input
                                className={styles.printOnlyHide}
                                value={city}
                                onChange={(e) => setCity(e.target.value)}
                                placeholder="City/State"
                            />
                            <span className={styles.printOnlyShow}>{city}</span>
                        </div>

                        <div className={styles.printLabelGroup}>
                            <label>Postal Code:</label>
                            <input
                                className={styles.printOnlyHide}
                                value={postal}
                                onChange={(e) => setPostal(e.target.value)}
                                placeholder="Postal Code"
                            />
                            <span className={styles.printOnlyShow}>{postal}</span>
                        </div>

                        <div className={styles.printLabelGroup}>
                            <label>Email:</label>
                            <input
                                className={styles.printOnlyHide}
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Email Address"
                            />
                            <span className={styles.printOnlyShow}>{email}</span>
                        </div>
                        <div className={styles.printLabelGroup}>
                            <label>WareHouse:</label>
                           
                            <span>{dataPO?.whareHouse?.warehouse?.code || '-'}</span>
                        </div>




                    </div>
                    <Heading heading={'Purchase Order'} headingStyle={styles.Heading} />
                </div>
                <div className={classNames(styles.billingToPo)}>
                    <div className={classNames(styles.billto, styles.cusFlex)}>
                        <h6>Bill to</h6>
                        <label>Name: {dataPO.supplier?.name || '-'}</label>
                        <label>Address: {dataPO.supplier?.address || '-'}</label>
                        <label>Phone: {dataPO.supplier?.phone || '-'}</label>
                    </div>
                    <div className={classNames(styles.billto)}>
                        <h6>Purchase Order#:{dataPO?.order_number}</h6>
                        <div className="d-flex align-items-center">
                            <h6 className="mb-0">Date:</h6>
                            <span className="ps-2">{moment(dataPO?.created_at).format('DD, MMM YYYY')}</span>
                        </div>
                    </div>
                </div>
                <div className={classNames(styles.poItems)}>
                    {/* <div className={classNames(styles.flexover)}>
                        <h6>Sku:</h6>
                        <label>{dataPO?.sku}</label>
                    </div> */}
                    <table border="0" className={classNames(styles.cusTable)}>
                        <thead>
                            <tr>
                                <th style={{ width: '40%' }} className="text-start">Description</th>
                                <th style={{ width: '15%' }} className="text-center">SKU</th>
                                <th style={{ width: '15%', whiteSpace: 'nowrap' }} className="text-center">Quantity</th>
                                <th style={{ width: '15%', whiteSpace: 'nowrap' }} className="text-center">Rate/per</th>
                                <th style={{ width: '15%', whiteSpace: 'nowrap' }} className="text-end">Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {dataPO?.order?.map((Item, inx) => (
                                <tr key={inx}>
                                    <td className="text-start">
                                        <div>
                                            <div>{Item.brand?.name}, {Item.compatiableBrand?.name}</div>
                                            <strong>{Item.product?.name}</strong>
                                            <div>{Item.product_category?.name}, {Item.sub_category?.name}, {Item.color}</div>
                                        </div>
                                    </td>
                                    <td className="text-center" style={{ whiteSpace: 'nowrap' }}>{Item?.sku}</td>
                                    <td className="text-center" style={{ whiteSpace: 'nowrap' }}>{Item.quantity}</td>
                                    <td className="text-center" style={{ whiteSpace: 'nowrap' }}>{formatPrice(Item.price)}</td>
                                    <td className="text-end" style={{ whiteSpace: 'nowrap' }}>{formatPrice(Item.amount)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <div className={classNames(styles.ourdress, styles.subtotle)}>
                        <div className={classNames(styles.custmstotal)}>
                            <div className={classNames(styles.subtotleItems)}>
                                <h6>Total</h6>
                                <OverlayTrigger
                                    key={'top'}
                                    placement={'top'}
                                    overlay={
                                        <Tooltip id={`tooltip-${'top'}`}>
                                            {dataPO?.order
                                                .map((ii) => ii.amount)
                                                .reduce((accumulator, currentValue) => {
                                                    return accumulator + currentValue;
                                                }, 0)}
                                        </Tooltip>
                                    }
                                >
                                    <label>
                                        {formatPrice(
                                            dataPO?.order
                                                .map((ii) => ii.amount)
                                                .reduce((accumulator, currentValue) => {
                                                    return accumulator + currentValue;
                                                }, 0)
                                        )}
                                    </label>
                                </OverlayTrigger>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={classNames(styles.reference)}>
                    <div className={classNames(styles.linkSite)}>
                        <a href="/">wisetech.com</a>
                    </div>
                    <div className={classNames(styles.logo)}>
                        <img src={logoSite} />
                    </div>
                </div>
            </div>
        </div>
    );
}
